var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.904,
    height: 23.488,
    viewBox: "0 0 16.904 23.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1954198_order_list_icon",
    "data-name": "1954198_order_list_icon",
    transform: "translate(-29.675 -22.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27947",
    "data-name": "Path 27947",
    d: "M51.845,38.49V24.727A1.727,1.727,0,0,0,50.118,23H41.564",
    transform: "translate(-6.216)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27948",
    "data-name": "Path 27948",
    d: "M33.431,23H32.352a1.727,1.727,0,0,0-1.727,1.727V42.861a1.727,1.727,0,0,0,1.727,1.727H43.9a1.727,1.727,0,0,0,1.727-1.727v-2.59",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_481",
    "data-name": "Line 481",
    x2: 8.953,
    transform: "translate(33.651 33.794)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_482",
    "data-name": "Line 482",
    x2: 5.475,
    transform: "translate(33.65 38.548)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_483",
    "data-name": "Line 483",
    x2: 8.953,
    transform: "translate(33.651 29.04)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrders);
export default __webpack_public_path__ + "static/media/TotalOrders.cbe886f99a886ec5a7c5eed785dc85de.svg";
export { ForwardRef as ReactComponent };